// extracted by mini-css-extract-plugin
export var active = "_fl-2";
export var recordingDot = "_fl-1";
export var recordingIndicator = "_fl-0";